const COMMON_PPREFIX = 'store/videosReducer';

export const SET_PROCESSING = `${COMMON_PPREFIX}/SET_PROCESSING`;
export const FETCH_VIDEOS = `${COMMON_PPREFIX}/FETCH_VIDEOS`;
